import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./View/Login/Login";
import Home from "./View/Home/Index";
import ProtectedRoute from "./components/ProtectedRoutes";
import AppLogout from "./utilities/AppLogout";
import ForgotPassword from "./View/ForgotPassword/ForgotPassword";
import ErrorBoundary from "./components/ErrorBoundary";


function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={
          <AppLogout>
            <ProtectedRoute>
              <ErrorBoundary>
                <Home />
              </ErrorBoundary>
            </ProtectedRoute>
          </AppLogout>
        } />
        <Route path="/login" element={<Login></Login>} />
        <Route path="/forgot-password" element={<ForgotPassword></ForgotPassword>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App; 